import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { DICTIONARY } from '@/config/dictionary';
import { APP_PATHS } from '@/config/routes/app-paths';
import { useAppStore } from '@/stores/app-store';
import { ensureValidPath } from '@/utils/validate-path';

export function useAuthExpired() {
  const clearSession = useAppStore((s) => s.clearSession);
  const addNotification = useAppStore((s) => s.addNotification);
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthExpired = () => {
      clearSession();
      void navigate({ to: ensureValidPath(APP_PATHS.home), search: { tab: 'signin' } });
      addNotification({
        type: 'warning',
        title: DICTIONARY.sessionTimeout.toastTitle,
        message: DICTIONARY.sessionTimeout.authExpiredToastDescription,
      });
    };

    window.addEventListener('auth:expired', handleAuthExpired);
    return () => {
      window.removeEventListener('auth:expired', handleAuthExpired);
    };
  }, [clearSession, addNotification, navigate]);
}
